import React, { useState } from 'react';
import { Modal, Form, Radio, Input } from 'antd';

interface IProps {
    showMaterialColorModal: string | null;
    handleSubmit: () => void;
    handleModalCancel: () => void;
    fieldName?: (name: string) => string;
}

const PlasticMaterialPreferencesModal: React.FC<IProps> = props => {
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
    const { showMaterialColorModal, handleSubmit, handleModalCancel, fieldName } = props;
    const form = Form.useFormInstance();

    return (
        <>
            <Modal
                title="Plastic Material Preferences"
                open={!!showMaterialColorModal}
                onOk={handleSubmit}
                onCancel={handleModalCancel}
                destroyOnClose={true}
                okButtonProps={{
                    disabled: isSubmitButtonDisabled,
                }}
                okText="Submit"
            >
                {showMaterialColorModal == 'transparent' ? (
                    <Form form={form} layout="vertical">
                        <Form.Item
                            name={fieldName ? fieldName('isTransparent') : 'isTransparent'}
                            label="Would you like the part to be optically clear (transparent)?"
                        >
                            <Radio.Group
                                onChange={() => {
                                    setIsSubmitButtonDisabled(false);
                                }}
                            >
                                <Radio value="yes">Yes</Radio>
                                <Radio value="no">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                ) : (
                    <>
                        <Form.Item
                            name={fieldName ? fieldName('preferredColor') : 'preferredColor'}
                            label="Please enter your preferred color (white, black, natural, etc.):"
                            rules={[{ required: true, message: 'Please enter a color.' }]}
                        >
                            <Input
                                onChange={e => {
                                    setIsSubmitButtonDisabled(e.target.value.trim() === '');
                                }}
                            />
                        </Form.Item>
                    </>
                )}
            </Modal>
        </>
    );
};

export default PlasticMaterialPreferencesModal;
